export const label = (value?: string | null) => value ? value.replaceAll('_', ' ') : 'Unknown';

export const compactMoney = (value?: number | null, currency = 'USD') => value == null
  ? 'Undisclosed'
  : new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      notation: 'compact',
      maximumFractionDigits: 1,
    }).format(value);

// A band rather than a figure, and `null` rather than a placeholder when the
// employer stated nothing: most postings state no pay, and a column of
// "Undisclosed" would crowd out the ones that do. The currency is coerced
// because the wire may carry null, which `Intl` rejects but a default does not
// catch — a default only applies to `undefined`.
export const payBand = (min?: number | null, max?: number | null, currency?: string | null) => {
  if (min == null) return null;
  const unit = currency || 'USD';
  return max == null || max === min
    ? compactMoney(min, unit)
    : `${compactMoney(min, unit)} – ${compactMoney(max, unit)}`;
};

export const formatDate = (value?: string | null) => value
  ? new Intl.DateTimeFormat('en-US', { dateStyle: 'medium' }).format(new Date(value))
  : 'Date unknown';

// Readiness levels are published ordinal scales (TRL is ISO 16290:2013), so the
// ceiling is shown alongside the value: "4 of 9" is readable, a bare "4" is not.
export const readiness = (value?: number | null, ceiling = 9) => value == null
  ? 'Not assessed'
  : `${value} of ${ceiling}`;
